import React, { useState } from 'react';
import {
  Drawer, makeStyles, withStyles,
} from '@material-ui/core';
import config from '@/configs/config';
import { isEmpty } from 'lodash';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import PreOrder from '../../containers/productDetailModal/PreOrder';
import High from './High';
import Empty from './Empty';
import Low from './Low';
import { ICE_LEVEL, SUGAR_LEVEL, SUGAR_LEVEL_STRING } from '../../constants';

const STATUS_COMPONENT_MAP = {
  0: Empty,
  1: Low,
  2: High,
  3: PreOrder,
};

const useStyles = makeStyles((theme) => ({
  providerName: {
    fontWeight: 'bold',
  },
  productName: {
    fontWeight: 'bold',
  },
  price: {
    fontWeight: 'bold',
    fontFamily: 'Roboto',
  },
  calories: {
    color: '#589664',
    fontSize: 13,
  },
  detail: {
    color: '#4f4f4f',
    fontSize: 13,
    marginTop: theme.spacing(1),
    marginBottom: 0,
  },
  hr: {
    marginTop: theme.spacing(1),
    width: '100%',
  },
  header: {
    flexShrink: 0,
    overflow: 'auto',
  },
  body: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    overflow: 'hidden',
    padding: theme.spacing(0, 1, 1),
  },
  footer: {
    flexShrink: 0,
  },
  gap: {
    flexGrow: 1,
    flexShrink: 1,
  },
  goBack: {
    background: '#d8d8d8',
    border: 0,
    borderRadius: 8,
    color: 'black',
    fontSize: 16,
    fontWeight: 'bold',
    padding: theme.spacing(0.5),
    width: '100%',
  },
  statusComponent: {
    color: '#4f4f4f',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 13,
    marginTop: theme.spacing(1),
    overflow: 'hidden',
  },
  infoContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  infoImageContainer: {
    maxWidth: 80,
    maxHeight: 80,
    flexShrink: 0,
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  sugarLevelContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  sellPrice: {
    color: theme.palette.price.onSale,
    marginLeft: 8,
    fontFamily: 'Roboto',
  },
}));

const StyledDrawer = withStyles((theme) => ({
  paper: {
    alignItems: 'stretch',
    display: 'flex',
    flexDirection: 'column',
    fontSize: 16,
    padding: theme.spacing(3, 0),
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    maxHeight: '90%',
    overflow: 'hidden',

    [theme.breakpoints.up('sm')]: {
      margin: '0 auto',
      width: 425,
    },

    '& > *': {
      paddingLeft: theme.spacing(3.5),
      paddingRight: theme.spacing(3.5),
    },
  },
}))(Drawer);

const StyledToggleButton = withStyles((theme) => ({
  root: {
    width: 70,
    color: '#4f4f4f !important',
  },
  selected: {
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
}))(ToggleButton);

export default ({
  data,
  isOpen,
  onClose: propsOnClose,
}) => {
  const classes = useStyles();
  const {
    calories,
    expireDay,
    expireDayDescription,
    ingredients,
    inventory,
    name,
    price,
    productNumber,
    provider,
    sellPrice,
    specification,
    showDrinkOptions,
  } = data;

  const [sugarLevelError, setSugarLevelError] = useState(false);
  const [sugarLevel, setSugarLevel] = useState(null);
  const StatusComponent = STATUS_COMPONENT_MAP[inventory];
  const priceString = (sellPrice || price) < price
    ? (
      <div style={{ display: 'flex', alignItems: 'end' }}>
        <div style={{
          fontSize: 13,
          textDecoration: 'line-through',
          fontFamily: 'Roboto',
        }}
        >
          {`原價$${price}`}
        </div>
        <div className={classes.sellPrice}>
          {`折扣後$${sellPrice}`}
        </div>
      </div>
    )
    : `$${price}`;

  const isValid = () => {
    if (showDrinkOptions && isEmpty(sugarLevel)) {
      setSugarLevelError(true);

      return false;
    }

    setSugarLevelError(false);

    return true;
  };

  const onSugarLevelChange = (e, value) => {
    if (!value) return;
    setSugarLevel(value);
    setSugarLevelError(false);
  };

  const onClose = () => {
    propsOnClose();
    setSugarLevel(null);
    setSugarLevelError(false);
  };

  return (
    <StyledDrawer
      anchor="bottom"
      onClose={onClose}
      open={isOpen}
    >
      <div className={classes.header}>
        <div className={classes.infoContainer}>
          <div>
            <div className={classes.providerName}>{`【${provider} 】`}</div>
            <div className={classes.providerName}>{name}</div>
            <div className={classes.price}>{priceString}</div>
            <div className={classes.calories}>{calories}</div>
          </div>
          <div className={classes.infoImageContainer}>
            <img src={`${config.RESOURCE_URI}ProductImages/${productNumber}.jpg`} alt="" width="100%" />
          </div>
        </div>
        <div className={classes.detail}>
          {specification && <div>{`規格：${specification}`}</div>}
          {ingredients && <div>{`成分：${ingredients}`}</div>}
          {(expireDay || expireDayDescription) && <div>{`保存期限：${expireDayDescription || `${expireDay} 天`} `}</div> }
          <div>有效期限：如包裝標示</div>
        </div>
        {showDrinkOptions ? (
          <div className={classes.detail}>
            <div>
              <span>冰量：一律去冰</span>
            </div>
            <div className={classes.sugarLevelContainer}>
              <span>
                <font style={{ color: '#a80000' }}>*必填</font>
                請選擇甜度：
              </span>
              <div>
                <ToggleButtonGroup size="small" exclusive onChange={onSugarLevelChange} value={sugarLevel}>
                  <StyledToggleButton value={SUGAR_LEVEL.NO}>
                    {SUGAR_LEVEL_STRING.NO}
                  </StyledToggleButton>
                  <StyledToggleButton value={SUGAR_LEVEL.NORMAL}>
                    {SUGAR_LEVEL_STRING.NORMAL}
                  </StyledToggleButton>
                </ToggleButtonGroup>
                {sugarLevelError ? <div style={{ color: '#a80000' }}>請選擇甜度</div> : null}
              </div>
            </div>
          </div>
        ) : null}
        <hr className={classes.hr} />
      </div>
      <div className={classes.body}>
        {StatusComponent && (
          <div className={classes.statusComponent}>
            <StatusComponent
              data={{
                ...data,
                ...(showDrinkOptions && {
                  options: {
                    sugarLevel,
                    iceLevel: ICE_LEVEL.NO,
                  },
                }),
              }}
              isValid={isValid}
              onClose={onClose}
            />
          </div>
        )}
      </div>
      <div className={classes.footer}>
        <button
          className={classes.goBack}
          onClick={onClose}
          type="button"
        >
          回到菜單
        </button>
      </div>
    </StyledDrawer>
  );
};
